import { Section } from '@/components/shared/Content';
import avatar from '@/static/partners/persona.png';
import { Box, Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import Image from 'next/image';
import type React from 'react';
import styled from 'styled-components';

const TestimonialsSection = styled(Section)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.light};

  ${MEDIA_QUERIES.desktop`
        height: 460px;
    `}
`;

const Quote = styled.p`
  ${font('alt', {
    fontSize: '2.0rem',
    lineHeight: '3.5rem',
    fontWeight: 300,
  })};
  font-style: italic;
  text-align: center;
  white-space: normal;
  max-width: 100%;

  ${MEDIA_QUERIES.tabletAndDesktop`
        font-size: 3.2rem;
        line-height: 5.2rem;
    `}

  ${MEDIA_QUERIES.desktop`
        white-space: pre;
    `}
`;

const PersonName = styled.p`
  ${font('main', { fontSize: '2.0rem' })};
  text-align: center;
`;

const PersonJob = styled.p`
  ${font('main', {
    fontSize: '1.6rem',
    lineHeight: '1.8rem',
    fontWeight: 300,
  })};

  ${MEDIA_QUERIES.tabletAndDesktop`
        ${font('main', { fontSize: '2.0rem' })};

        &:before {
            content: ", ";
        }
    `}
`;

interface TestimonialsProps {
  content: string;
  personName: string;
  personTitle: string;
}

export const Testimonials: React.FC<TestimonialsProps> = ({ content, personName, personTitle }) => {
  return (
    <TestimonialsSection py={[80, 70, 100]} px={[30, 60]}>
      <Quote>{`“${content}”`}</Quote>
      <Flex mt={[25, 20, 35]} flexDirection={['column', 'row']} alignItems="center" justifyContent="center">
        <Image width="48" height="42" src={avatar} alt="avatar" />
        <Box my="6px" ml={[0, '2px']}>
          <PersonName>{personName}</PersonName>
        </Box>
        <PersonJob>{personTitle}</PersonJob>
      </Flex>
    </TestimonialsSection>
  );
};
